import { useEffect, useState } from "react";
import "./styles/WelcomeModal.css";

export default function WelcomeModal({ text, show, onClose, type = "guest" }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
    }
  }, [show]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleCreateMemorial = () => {
    window.location.href = "/xatire-yarat";
    handleClose();
  };

  if (!show && !isVisible) return null;

  return (
    <div className={`welcome-modal-overlay-wrapper ${isVisible ? "show" : ""}`}>
      <div className={`welcome-modal-container ${type} ${isVisible ? "show" : ""}`}>
        <div className="welcome-modal-text">
          {text}
        </div>

        {type === "user" && (
          <button 
            className="welcome-modal-btn welcome-modal-btn-create" 
            onClick={handleCreateMemorial}
          >
            Xatirə Yarat
          </button>
        )}

        <button 
          className="welcome-modal-btn welcome-modal-btn-close" 
          onClick={handleClose}
        >
          Bağla
        </button>
      </div>
    </div>
  );
}